import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full my-2"
}
const _hoisted_2 = { class: "flex flex-wrap justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "shrink-0 border-b border-gray-300 pb-2 mb-2 md:border-b-0 2xl:border-r md:pb-0 md:mb-0 md:pr-2 md:mr-2"
}
const _hoisted_4 = { class: "flex gap-x-1 flex-wrap mb-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-parameter-title text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }
const _hoisted_7 = { class: "shrink-0 min-w-0" }
const _hoisted_8 = { class: "w-full flex gap-x-1 flex-wrap mb-2 justify-center md:justify-end" }
const _hoisted_9 = ["onClick", "onMouseover"]
const _hoisted_10 = { class: "w-10 h-10 rounded-2xl flex" }
const _hoisted_11 = ["src", "srcset"]
const _hoisted_12 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }
const _hoisted_13 = { class: "text-parameter-title text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }

import {computed, inject, ref, watch} from "vue";
import {useStore} from "vuex";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import ItemV3StonesParameterLoading from "@/components/itemV3/parameter/stones/parameter/itemV3StonesParameterLoading.vue";

const variantIdx = ""

const stoneTypeImageSrc = "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_quality/rif-icon-300.webp"
const stoneTypeImageSrcset = "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_quality/rif-icon-600.webp"

/**
 * quality variants (transferred from itemV3StonePresetsStoneQuality.vue's "color variants")
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesQuality',
  props: {
    groupIdx: {}
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3StonePresetsStoneQuality.vue: configureAll/itemIdx are wired into
 * ParametersVariations the same way, but - like itemV3StonesSetting.vue / itemV3StonesStoneSize.vue -
 * the variants are fetched per stone group via getItemVariants(itemIdx, "stones.<groupIdx>.stone_quality")
 * / getItemVariants(itemIdx, "stones.<groupIdx>.stone_type") instead of the fixed
 * "stones.0.stone_quality" / "stones.*.stone_type" idx used there.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

/**
 * stone quality - stones.<groupIdx>.stone_quality
 * stone type - stones.<groupIdx>.stone_type
 */

const stoneQuality = ref({
  "stone_quality": {},
  "stone_type": {}
} as any)

const getStoneQualityData = (groupIdy: number) => {
  if (groupIdy >= 0) {
    stoneQuality.value.stone_quality = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_quality")
    stoneQuality.value.stone_type = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_type")
  }
}

watch(() => props.groupIdx, (groupIdy) => {
  getStoneQualityData(groupIdy)
}, {immediate: true})

watch(session, () => {
  getStoneQualityData(props.groupIdx)
}, {deep: true})

/**
 * stone type variants (transferred from itemV3StonePresetsStoneQuality.vue's "stone type variants"),
 * now rendered as cards (icon + title + subtitle) instead of a sliding switch-button bar.
 */

const stoneTypeVariants = computed(() => stoneQuality.value.stone_type)

// subtitles shown below the stone type title, matching the attached layout
// ("Diamant" / "Brillant", "Labor Diamant" / "Nachhaltig", "Zirkonia" / "Strahlend")
const stoneTypeSubtitles: Record<string, string> = {
  earth: "Brillant",
  lab: "Nachhaltig",
  zirconia: "Strahlend",
}

const getStoneTypeSubtitle = (idx: string) => stoneTypeSubtitles[idx?.toLowerCase()] || ""

// all stone type cards share the same "rif" stone quality icon as their image
const active = computed(() => stoneQuality.value.stone_quality[0])

const variantsList = computed(() => active.value?.values || [])

const matchedIdx = computed(() => variantsList.value.findIndex((v: any) => v.match))

/**
 * hover
 */

const hoverIdx = ref(-1)

const setHoverIdx = () => {
  if (matchedIdx.value !== -1 && variantsList.value.length >= matchedIdx.value) {
    hoverIdx.value = matchedIdx.value
  }
}

watch(active, () => {
  setHoverIdx()
})

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};


return (_ctx: any,_cache: any) => {
  return (active.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (stoneTypeVariants.value.length >= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stoneTypeVariants.value[0].values, (stoneType, stoneTypeIdx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: stoneTypeIdx,
                      class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
                'border-2 border-brand-main bg-[#f3f0e9]': stoneType.match,
                'border-2 border-transparent': !stoneType.match
              }]),
                      onClick: ($event: any) => (handleValuePatch(stoneTypeVariants.value[0].idx, stoneType))
                    }, [
                      _createElementVNode("div", { class: "w-10 h-10 rounded-2xl flex" }, [
                        _createElementVNode("img", {
                          src: stoneTypeImageSrc,
                          srcset: stoneTypeImageSrcset,
                          class: "object-cover"
                        })
                      ]),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(stoneType.title), 1)
                    ], 10, _hoisted_5))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (variantData, variantIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
                'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
                'border-2 border-transparent': !variantData.match
              }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData)),
                  onMouseover: ($event: any) => (hoverIdx.value = variantIdx as number),
                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverIdx.value = matchedIdx.value))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_quality/${variantData.idx.toLowerCase()}-icon-300.webp`,
                      srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_quality/${variantData.idx.toLowerCase()}-icon-600.webp`,
                      class: "object-cover"
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(variantData.title), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$n(variantData.price, 'currency')), 1)
                ], 42, _hoisted_9))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(ItemV3StonesParameterLoading, { key: 1 }))
}
}

})